<script>
import { useNavigationPagesStructuredDataProductSheet } from "@/mixins/seo/navigationPagesStructuredDataProductSheet";
import ButtonIcon from "@/components/molecules/button-icon";
import Breadcrumbs from "@/components/molecules/breadcrumbs/default";
import { pageProductSheetProps, usePageProductSheet } from "./mixin";
import { useProductSheetBreadcrumb } from "@/components/organisms/product-sheet/mixins/product-sheet-breadcrumb.mixin";
import Button from "@/components/atoms/button";
import HtmlParser from "@/components/organisms/cms-container/html-parser";

import ProductDetails from "@/containers/product-sheet/product-details";
import PushProductsBlock from "@/containers/product-sheet/push-products-block";
import AdditionalDetails from "@/containers/product-sheet/additional-details";
import ProductReviewDetails from "@/containers/product-sheet/product-reviews-details";
import Container from "@/components/atoms/container";

export default {
  name: "ProductSheet",
  components: {
    ButtonIcon,
    Breadcrumbs,
    Button,
    HtmlParser,
    ProductDetails,
    PushProductsBlock,
    AdditionalDetails,
    ProductReviewDetails,
    Container
  },
  methods: {
    backUrl() {
      if (!this.fromUrl.name) {
        navigateToInternal(this.parentLevel);
      } else {
        this.$router.go(-1);
      }
    }
  },
  props: {
    ...pageProductSheetProps()
  },
  setup(props) {
    const { parentLevel, breadcrumbs } = useProductSheetBreadcrumb(props);
    const {
      hasSyndigoContent,
      ProductSheetCodes,
      fromUrl,
      productInfo,
      photos,
      pushZoneTitle,
      recettePosition,
      getPushData,
      hasReviews,
      mounted
    } = usePageProductSheet(props);

    const { head } = useNavigationPagesStructuredDataProductSheet(
      productInfo.value,
      props.product,
      props.reviews,
      props.statistics,
      breadcrumbs.value
    );

    useHead(head);

    onMounted(mounted);
    return {
      parentLevel,
      breadcrumbs,
      hasSyndigoContent,
      ProductSheetCodes,
      fromUrl,
      productInfo,
      photos,
      pushZoneTitle,
      recettePosition,
      hasReviews,
      getPushData
    };
  }
};
</script>

<template>
  <div
    v-if="productInfo"
    class="u-bgcolor-white"
  >
    <Container>
      <Breadcrumbs
        class="u-mr-sm u-ml-sm"
        :breadcrumbs="breadcrumbs"
      />
    </Container>
    <div>
      <Container
        v-if="backButton && parentLevel"
        class="Desk_FP_Details_1"
      >
        <ButtonIcon
          icon-name="arrow-left"
          icon-color="text"
          icon-color-hover="primary-light"
          text-hover-color="primary-light"
          class="u-mt-sm"
          size="xs"
          :to="parentLevel"
          @click="backUrl"
        >
          Retour
        </ButtonIcon>
      </Container>
      <div class="u-bgcolor-white Desk_FP_Details_2">
        <ProductDetails
          :photos="photos"
          :product="product"
          :breadcrumb="breadcrumb"
          :is-replaced-by-national="isReplacedByNational"
          :is-popin="isPopin"
          :from-prospectus="fromProspectus"
        />
      </div>
      <div class="u-bgcolor-bg u-pb-sm Desk_FP_Suggestions">
        <Container v-if="!isReplacedByNational && productInfo.associations && (productInfo.associations.alternatifs && productInfo.associations.alternatifs.data && productInfo.associations.alternatifs.data.length > 0 || productInfo.associations.similaire && productInfo.associations.similaire.data.length > 0 )">
          <h2 class="c-product-sheet-page__heading">
            {{ pushZoneTitle }}
          </h2>
          <client-only>
            <PushProductsBlock
              zone="up"
              :recette-index="recettePosition"
              :product="product"
            />
          </client-only>
          <div
            v-if="parentLevel"
            class="u-text-center u-mt-sm u-pb-lg"
          >
            <Button
              variant="primary"
              size="sm"
              radius="full"
              :to="parentLevel"
            >
              Voir les produits similaires
            </Button>
          </div>
        </Container>
      </div>
      <HtmlParser
        v-if="getPushData(ProductSheetCodes.FP_ZONE_LIBRE).html_content"
        class="c-cms-container__content u-px-sm u-pt-md"
        :content="getPushData(ProductSheetCodes.FP_ZONE_LIBRE).html_content"
      />
      <client-only>
        <div
          v-show="hasSyndigoContent"
          class="c-product-sheet-page__syndigo-container"
        >
          <h2 class="u-text-center u-color-primary u-pt-md u-pb-md">
            La marque vous informe
          </h2>
          <div id="syndi_inline"></div>
        </div>
      </client-only>
      <AdditionalDetails
        class="Desk_FP_Infos"
        :product-info="productInfo"
      />
      <div class="u-bgcolor-bg u-pb-sm">
        <Container v-if=" productInfo.associations && productInfo.associations.protection && productInfo.associations.protection.data.length > 0 ">
          <h2 class="c-product-sheet-page__heading">
            Pensez à vous protéger
          </h2>
          <client-only>
            <PushProductsBlock
              zone="down"
              :product="product"
            />
          </client-only>
        </Container>
      </div>
      <div
        v-if="hasReviews"
        class="u-bgcolor-white u-pt-md u-pb-md u-mt-md "
      >
        <container>
          <div
            id="avis-clients"
            class="Desk_FP_Avis"
          >
            <ProductReviewDetails
              :shop-id="shopId"
              :reviews="reviews"
              :statistics="statistics"
              :product-id="parseInt(product.id)"
            />
          </div>
        </container>
      </div>
      <div />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-sheet.scss";
@import "@/assets/styles/globals/cms.scss";

/** Ajout dev */
.c-product-sheet-page__syndigo-container {
  max-width: 100rem;
  margin: 0 auto;
}
</style>
